import * as React from 'react'
import {
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  InputAdornment,
  Radio,
  RadioGroup,
  TextField,
} from '@material-ui/core'
import { jt, t } from 'ttag'

import { ReactComponent as GearIcon } from '../../assets/icons/gear.svg'
import { ReactComponent as EditIcon } from '../../assets/icons/pencil.svg'
import { ReactComponent as PrivacyIcon } from '../../assets/icons/privacy.svg'
import { ReactComponent as SyncIcon } from '../../assets/icons/sync.svg'
import { ReactComponent as DeleteIcon } from '../../assets/icons/trash.svg'
import { ReactComponent as CancelIcon } from '../../assets/v2/icons/cancel.svg'
import { ReactComponent as EmailIcon } from '../../assets/v2/icons/support.svg'
import { ReactComponent as AddIcon } from '../../assets/v3/icons/add.svg'

import { ReactComponent as CheckboxSelectedIcon } from '../../assets/v3/icons/checkbox-selected.svg'
import { ReactComponent as CheckboxIcon } from '../../assets/v3/icons/checkbox.svg'

import { ReactComponent as LockIcon } from '../../assets/v2/icons/lock.svg'
import { ReactComponent as LockFilledIcon } from '../../assets/v2/icons/lock-filled.svg'

import { ReactComponent as StarIcon } from '../../assets/v2/icons/star.svg'
import { ReactComponent as StarFilledIcon } from '../../assets/v2/icons/star-filled.svg'

import {
  convertCmToFtIn,
  convertFtInToCm,
  DATE_FORMAT,
  getServiceProviderLabel,
  isDateOfBirthErrorVisible,
  isDateOfBirthValid,
  isNumberFieldErrorVisible,
  isTextFieldErrorVisible,
  precisionRoundMod,
} from '../../common/helpers/formHelpers'
import { isIOS } from '../../common/helpers/isNative'
import { getFullName } from '../../common/helpers/translations'
import { ROUTES } from '../../common/Routes/routePaths'
import { Button } from '../../components/Button/Button'
import { ButtonGroup } from '../../components/ButtonGroup/ButtonGroup'
import { Card } from '../../components/Card/Card'
import { Initials } from '../../components/Initials/Initials'
import NotificationsWrapper from '../../components/Notification/NotificationsWrapper'
import {
  ChangePassword$Request,
  CompanyCountriesDto,
  CompanyId,
  DeleteUserOwnedCompany$Request,
  DivisionDto,
  DivisionId,
  Gender,
  JoinCompany$Request,
  Lang,
  LeaveCompany$Request,
  Role,
  ServiceProvider,
  SetUserCountry$Request,
  SetUserDivision$Request,
  Units,
  UserCompanyDto,
  UserId,
  UserProfileDto,
} from '../../services/api.types'
import './Settings.scss'
import { currentLang, isRtl } from '../../i18nInit'
import moment from 'moment'

import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import YumCountrySelect from '../../components/YumCountrySelect/YumCountrySelect'
import YumTimeZoneSelect from '../../components/YumTimeZoneSelect/YumTimeZoneSelect'
import {
  isCompanyCountryRequired,
  isCompanyDivisionRequired,
  MIN_HEIGHT_CM,
  MIN_WEIGHT_KG,
} from '../RegisterUser/RegisterUser'
import { CellInfo, Column, RowInfo } from 'react-table'
import { Table } from '../../components/Table/Table'
import FormLabel from '@material-ui/core/FormLabel'
import { dataSync, refreshActivityView } from '../../services/DataSync'
import { openPrivacyPolicy, openTermsOfService } from '../../common/helpers/routeHelpers'
import { scrollToTop } from '../../common/helpers/scroll'
import { Capacitor } from '@capacitor/core'
import YumSwitch from '../../components/YumSwitch/YumSwitch'
import { red } from '../../styles/material-ui-theme-v2'
import { YumLanguageSelection } from '../../components/YumLanguageSelection/YumLanguageSelection'
import {
  unitsCountLengthCentimeterShort,
  unitsCountLengthFootShort,
  unitsCountLengthInchShort,
  unitsCountMassKilogramShort,
  unitsCountMassPoundShort,
} from '../../common/helpers/units'
import YumSelect from '../../components/YumSelect/YumSelect'
import YumInput from '../../components/YumInput/YumInput'
import { ReactComponent as DateActiveIcon } from '../../assets/v3/icons/date-active.svg'
import { ReactComponent as DateInactiveIcon } from '../../assets/v3/icons/date-inactive.svg'
import { ReactComponent as WeightActiveIcon } from '../../assets/v3/icons/weight-active.svg'
import { ReactComponent as WeightInactiveIcon } from '../../assets/v3/icons/weight-inactive.svg'
import { ReactComponent as HeightActiveIcon } from '../../assets/v3/icons/height-active.svg'
import { ReactComponent as HeightInactiveIcon } from '../../assets/v3/icons/height-inactive.svg'
import { store } from '../../index'
import { addNotification } from '../../common/notifications/NotificationActions'
import { INotification } from '../../common/notifications/NotificationReducers'
import { getShortDateString, getShortDateWithTimeString } from '../../common/helpers/date'
import YumTeamSelect from '../../components/YumTeamSelect/YumTeamSelect'

const convert = require('convert-units')

export interface IChangePasswordPayload extends ChangePassword$Request {
  confirmPassword: string
}

export interface IStateProps {
  hasRole(role: Role): boolean
  userDto: UserProfileDto
  //activity: ActivityProgress
  countries: CompanyCountriesDto[]
  divisions: DivisionDto[]
  userCompanies: UserCompanyDto[]
}

export interface UpdateUserProfileState {
  country: string
  dateOfBirth: string | null
  divisionId: DivisionId
  firstName: string
  gender: Gender | null
  height: number | null
  lastName: string
  newsletterSubscriber: boolean
  onlyProfileUpdate: boolean
  timeZone: string
  units: Units | null
  weight: number | null
}

export interface IDispatchProps {
  syncIntegration(payload: { noMessage: boolean }): void
  endIntegration(): void
  //getUserActivity(): void
  getUserCompanyCountries(): void
  getCompanyDivisions(): void
  deleteUser(payload: { userId: UserId; companyId: CompanyId | null }): void
  changePassword(payload: IChangePasswordPayload): void
  changeUserLanguage(payload: Lang): void
  appleHealthIntegration(): void
  updateUser(payload: UpdateUserProfileState): void
  joinCompany(payload: JoinCompany$Request): void
  leaveCompany(payload: LeaveCompany$Request): void
  deleteUserOwnedCompany(payload: DeleteUserOwnedCompany$Request): void
  setUserDivision(payload: SetUserDivision$Request): void
  setUserCountry(payload: SetUserCountry$Request): void
  hasRoleInCompany(companyId: CompanyId, role: Role): boolean
  togglePublicStatus(): void
  getWhoAmI(): void
}

type ISettingsProps = IStateProps & IDispatchProps

export interface ISettingsState {
  oldPassword: string
  newPassword: string
  confirmPassword: string
  isDeleteModalOpen: boolean
  isLeaveModalOpen: boolean
  leaveCompanyId: CompanyId | null
  leaveCompanyName: string
  isLeaveCompanyOwner: boolean
  editServiceProvider: boolean
  joinCompany: boolean
  signUpCode: string
  editProfile: boolean
  editPassword: boolean
  hasActivityIndexData: boolean

  firstName: string
  lastName: string
  email: string
  dateOfBirth: string
  gender: Gender.MALE | Gender.FEMALE
  units: Units.METRIC | Units.IMPERIAL
  weight: string | number
  weightLbs: string | number
  height: string | number
  heightFt: string | number
  heightIn: string | number
  isProfileFormValid: boolean
  timeZone: string
  newsletterSubscriber: boolean

  publicChallengesJustClicked: boolean
}

const timeZone = moment.tz.guess(true)
const isUsa = timeZone.startsWith('America/')

export const yuMuuvPublicCompanyId = '2d098838-2d06-ea86-3445-b9d039fbd0d3'
export const myFitnessPublicCompanyId = 'be59656c-6ccb-4aaa-9eae-92cff1becd55'
export const noBananasPublicCompanyId = '96302717-6052-454e-ad70-94da580fa7e4'
export const tallinkPublicCompanyId = '7e90c098-4670-435d-8b1e-40e01ebbe0d5'
export const cachetPublicCompanyId = '44d1ff30-4a66-4f60-a4f2-081be6ce7f82'
export const hiltonPublicCompanyId = '52a930c6-5bf0-46d0-9952-35bf8e5d3fd7'

export const isPublicChallengeCompany = (companyId: CompanyId) => {
  return [
    yuMuuvPublicCompanyId,
    myFitnessPublicCompanyId,
    noBananasPublicCompanyId,
    tallinkPublicCompanyId,
    cachetPublicCompanyId,
    hiltonPublicCompanyId,
  ].includes(companyId)
}

export class Settings extends React.PureComponent<ISettingsProps, ISettingsState> {
  defaultProfile = {
    firstName: '',
    lastName: '',
    email: '',
    dateOfBirth: '',
    gender: Gender.MALE,
    units: isUsa ? Units.IMPERIAL : Units.METRIC,
    weight: '',
    height: '',
    timeZone,
    newsletterSubscriber: false,
  }
  state = {
    confirmPassword: '',
    isDeleteModalOpen: false,
    isLeaveModalOpen: false,
    leaveCompanyId: null,
    leaveCompanyName: '',
    isLeaveCompanyOwner: false,
    isProfileFormValid: true,
    newPassword: '',
    oldPassword: '',
    editServiceProvider: false,
    joinCompany: false,
    signUpCode: '',
    editProfile: false,
    editPassword: false,
    weightLbs: '',
    heightFt: '',
    heightIn: '',
    hasActivityIndexData: false,
    publicChallengesJustClicked: false,
    ...this.defaultProfile,
  }

  componentDidMount(): void {
    const { hasRole, getUserCompanyCountries, getCompanyDivisions, userDto, getWhoAmI } = this.props
    const isUser = hasRole(Role.USER)
    if (isUser) {
      getWhoAmI()
      getUserCompanyCountries()
      getCompanyDivisions()
      const {
        email,
        dateOfBirth: userDateOfBirth,
        gender: userGender,
        units: userUnits,
        height,
        weight,
        lastName,
        firstName,
        timeZone,
        newsletterSubscriber,
      } = userDto
      const dateOfBirth = userDateOfBirth ? moment(userDateOfBirth).format(DATE_FORMAT) : ''
      //const dateOfBirth = userDateOfBirth ? getShortDateString(moment(userDateOfBirth).locale('en').valueOf()) : ''
      const gender = userGender ? userGender : Gender.MALE
      const units = userUnits ? userUnits : Units.METRIC

      this.setState({
        email,
        dateOfBirth,
        gender,
        units,
        height,
        weight,
        lastName,
        firstName,
        timeZone,
        newsletterSubscriber,
        hasActivityIndexData: !!dateOfBirth,
      })
    }
  }

  componentDidUpdate(prevProps: Readonly<ISettingsProps>, prevState: Readonly<ISettingsState>, snapshot?: any): void {
    const { userDto } = this.props
    const { dateOfBirth, gender: userGender, units: userUnits, height, weight, lastName, firstName, timeZone } = userDto
    const gender = userGender ? userGender : Gender.MALE
    const units = userUnits ? userUnits : Units.METRIC

    if (prevProps.userDto !== userDto) {
      const userDOB = dateOfBirth ? moment(dateOfBirth).format(DATE_FORMAT) : ''
      //const userDOB = dateOfBirth ? getShortDateString(moment(dateOfBirth).locale('en').valueOf()) : ''
      const { heightFt, heightIn } = convertCmToFtIn(this.state.height)
      const weightLbs = precisionRoundMod(convert(weight).from('kg').to('lb'), 5)
      this.setState({
        dateOfBirth: userDOB,
        gender,
        units,
        height,
        weight,
        heightFt,
        heightIn,
        weightLbs,
        lastName,
        firstName,
        timeZone,
        hasActivityIndexData: !!dateOfBirth,
      })
    }
  }

  isProfileFormValid() {
    const { firstName, lastName, dateOfBirth, weight, height, hasActivityIndexData } = this.state

    if (!hasActivityIndexData) return !(!firstName || !lastName)

    const isWeightInvalid = weight ? parseInt(weight, 10) < MIN_WEIGHT_KG || weight.length === MIN_WEIGHT_KG : true
    const isHeightInvalid = height ? parseInt(height, 10) < MIN_HEIGHT_CM || height.length === MIN_HEIGHT_CM : true

    return !(!firstName || !lastName || !isDateOfBirthValid(dateOfBirth) || isWeightInvalid || isHeightInvalid)
  }

  syncData = async () => {
    const { syncIntegration, getWhoAmI, userDto } = this.props
    const { serviceProvider } = userDto
    const os = Capacitor.getPlatform()
    const appSync =
      (os === 'ios' && serviceProvider === ServiceProvider.APPLE_HEALTH) ||
      (os === 'android' && serviceProvider === ServiceProvider.GOOGLE_FIT)

    if (serviceProvider === ServiceProvider.APPLE_HEALTH && os !== 'ios') {
      const notification: INotification = {
        type: 'info',
        content: t`Download YuMuuv from the App Store. Log in with your email and password.`,
      }
      await store.dispatch(addNotification(notification))
      return
    }

    // Notify back-end and show message.
    //syncIntegration({ noMessage: appSync })
    syncIntegration({ noMessage: false })

    // So people see the message.
    scrollToTop()

    // If it's Apple Health or Google Fit, initiate sync from front-end.
    if (appSync) {
      await dataSync(true, true)
    }
    // Otherwise show syncing icon for 10 seconds.
    else {
      document.body.classList.add('is-syncing')
      getWhoAmI()
      setTimeout(() => {
        refreshActivityView()
        document.body.classList.remove('is-syncing')
      }, 30000)
    }
  }

  deleteUser = () => {
    const { deleteUser, userDto } = this.props
    deleteUser({ userId: userDto.userId, companyId: null })
  }

  changePassword = () => {
    const { changePassword } = this.props
    const { oldPassword, newPassword, confirmPassword } = this.state

    if (oldPassword && newPassword && confirmPassword) {
      changePassword({ oldPassword, newPassword, confirmPassword })
      this.setState({ editPassword: false, oldPassword: '', newPassword: '', confirmPassword: '' })
      scrollToTop()
    }
  }

  getGridLayout = (leftColumn: JSX.Element | JSX.Element[], rightColumn: JSX.Element | JSX.Element[]) => (
    <Grid container={true} justifyContent="space-between" className="settings__grid">
      <Grid item={true}>{leftColumn}</Grid>
      <Grid item={true} className="text-right">
        {rightColumn}
      </Grid>
    </Grid>
  )

  editProfile = () => {
    const { updateUser } = this.props
    const {
      dateOfBirth: userDateOfBirth,
      firstName,
      lastName,
      gender,
      height,
      weight,
      timeZone,
      units,
      newsletterSubscriber,
      hasActivityIndexData,
    } = this.state
    this.setState({ isProfileFormValid: this.isProfileFormValid() }, () => {
      if (this.state.isProfileFormValid) {
        const dateOfBirth = moment(userDateOfBirth, DATE_FORMAT).locale('en').format('YYYY-MM-DD')

        updateUser({
          dateOfBirth: hasActivityIndexData && dateOfBirth ? dateOfBirth : null,
          firstName,
          lastName,
          divisionId: null,
          country: '',
          timeZone,
          newsletterSubscriber,

          gender: hasActivityIndexData ? gender : null,
          height: hasActivityIndexData ? Number(height) : null,
          weight: hasActivityIndexData ? Number(weight) : null,
          units: hasActivityIndexData ? units : null,

          onlyProfileUpdate: true,
        })
        this.setState({ editProfile: false })
      }
    })
  }

  toggleEditServiceProvider = () => {
    this.setState({
      editServiceProvider: !this.state.editServiceProvider,
    })
  }

  cancelEditProfile = () => {
    const { userDto } = this.props
    const { editProfile } = this.state
    const { dateOfBirth, gender: userGender, height, weight, lastName, firstName } = userDto

    const gender = userGender ? userGender : Gender.MALE

    this.setState({
      dateOfBirth: dateOfBirth ? moment(dateOfBirth).locale('en').format(DATE_FORMAT) : '',
      //dateOfBirth: dateOfBirth ? getShortDateString(moment(dateOfBirth).locale('en').valueOf()) : '',
      gender,
      height,
      weight,
      lastName,
      firstName,
      editProfile: !editProfile,
    })
  }

  cancelEditPassword = () => {
    const { editPassword } = this.state

    this.setState({
      editPassword: !editPassword,
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
    })
  }

  endIntegration = async () => {
    const { endIntegration, getWhoAmI } = this.props
    await endIntegration()
    this.toggleEditServiceProvider()
    scrollToTop()

    setTimeout(() => {
      getWhoAmI()
    }, 1000)
  }

  triggerAppleHealthIntegration = () => {
    this.toggleEditServiceProvider()
    scrollToTop()
    this.props.appleHealthIntegration()
  }

  getIntegrationBlock = () => {
    const { userDto } = this.props
    const { editServiceProvider } = this.state
    const { lastSync, serviceProvider, dateOfBirth } = userDto

    //const lastSyncedFormatted = moment(lastSync).format('DD.MM.YYYY HH:mm')
    const lastSyncedFormatted = getShortDateWithTimeString(lastSync)

    const scope = dateOfBirth ? 'FULL' : 'LEAN'

    const syncSleep = this.props.userCompanies && this.props.userCompanies.some((uc) => uc.scope?.includes('syncSleep'))
    const withSleep = syncSleep ? '&s=1' : ''

    const IntegrateGoogleFit = `${ROUTES.INTEGRATION_PROXY.to}?type=${ServiceProvider.GOOGLE_FIT}&scope=${scope}${withSleep}`
    const IntegrateFitbit = `${ROUTES.INTEGRATION_PROXY.to}?type=${ServiceProvider.FITBIT}&scope=${scope}`
    const IntegrateGarmin = `${ROUTES.INTEGRATION_PROXY.to}?type=${ServiceProvider.GARMIN}&scope=${scope}`
    const IntegratePolar = `${ROUTES.INTEGRATION_PROXY.to}?type=${ServiceProvider.POLAR}&scope=${scope}`
    const IntegrateSuunto = `${ROUTES.INTEGRATION_PROXY.to}?type=${ServiceProvider.SUUNTO}&scope=${scope}`
    const IntegrateHuawei = `${ROUTES.INTEGRATION_PROXY.to}?type=${ServiceProvider.HUAWEI}&scope=${scope}`

    const integrations = [
      {
        name: 'Apple Health',
        url: isIOS ? undefined : 'https://itunes.apple.com/us/app/yumuuv/id1459357799?mt=8',
        onClick: isIOS ? this.triggerAppleHealthIntegration : undefined,
        externalLink: !isIOS,
      },
      { name: 'Fitbit', url: IntegrateFitbit },
      { name: 'Garmin', url: IntegrateGarmin },
      { name: 'Google Fit', url: IntegrateGoogleFit },
      //{ name: 'HUAWEI Health Kit (BETA)', url: IntegrateHuawei },
      { name: 'Polar', url: IntegratePolar },
      { name: 'Suunto', url: IntegrateSuunto },
    ]

    const integration = getServiceProviderLabel(serviceProvider)

    let showGenericSyncMessage = [
      ServiceProvider.POLAR,
      ServiceProvider.FITBIT,
      ServiceProvider.SUUNTO,
      ServiceProvider.HUAWEI,
    ].includes(serviceProvider)

    if (Capacitor.getPlatform() !== 'android' && serviceProvider === ServiceProvider.GOOGLE_FIT) {
      showGenericSyncMessage = true
    }

    return (
      <section className="settings__section">
        {this.getGridLayout(
          <>{lastSync ? <p className="text-gray">{t`Last sync`}:</p> : ''}</>,
          <>{lastSync ? <p className="text-gray">{lastSyncedFormatted}</p> : ''}</>,
        )}

        {serviceProvider ? (
          <ButtonGroup>
            <Button
              className="btn-sync"
              text={t`Update your data`}
              link={true}
              onClick={this.syncData}
              iconLeft={SyncIcon}
            />
          </ButtonGroup>
        ) : (
          <br />
        )}

        {this.getGridLayout(
          <p className="text-gray">{t`Integration`}:</p>,
          <p className="text-gray">
            {!serviceProvider
              ? t`NONE`
              : serviceProvider === ServiceProvider.HUAWEI
              ? `HUAWEI Health Kit`
              : integration}
          </p>,
        )}

        {editServiceProvider ? (
          <>
            <ButtonGroup>
              {integrations.map(({ name: integration, url, onClick, externalLink }) => (
                <Button
                  text={t`Connect with ${integration}`}
                  url={url}
                  link={true}
                  iconLeft={GearIcon}
                  key={integration}
                  onClick={onClick}
                  externalLink={externalLink || false}
                />
              ))}
              {/*<Button
                text={t`Connect with ${integration}`, {integration: 'Apple Health'}}
                link={true}
                onClick={isNative() ? this.triggerAppleHealthIntegration : undefined}
                iconLeft={AppleHealthIcon}
                url={isNative() ? undefined : 'https://itunes.apple.com/us/app/yumuuv/id1459357799?mt=8'}
                externalLink={!isNative() && true}
              />
              <Button text={t`Connect with Fitbit`} link={true} url={IntegrateFitbit} iconLeft={FitbitIcon} />
              <Button text={t`Connect with Garmin`} link={true} url={IntegrateGarmin} iconLeft={GarminIcon} />
              <Button text={t`Connect with Google Fit`} link={true} url={IntegrateGoogleFit} iconLeft={GoogleFitIcon} />
              <Button
                text={t`Connect with Huawei` + ' (BETA)'}
                link={true}
                url={IntegrateHuawei}
                iconLeft={HuaweiIcon}
              />
              <Button text={t`Connect with Polar`} link={true} url={IntegratePolar} iconLeft={PolarIcon} />
              <Button text={t`Connect with Suunto`} link={true} url={IntegrateSuunto} iconLeft={SuuntoIcon} />*/}
            </ButtonGroup>

            {serviceProvider ? (
              <ButtonGroup>
                <Button
                  text={t`Cancel authorization` + ` (${serviceProvider})`}
                  link={true}
                  onClick={this.endIntegration}
                  iconLeft={CancelIcon}
                />
              </ButtonGroup>
            ) : (
              ''
            )}
          </>
        ) : (
          ''
        )}

        <ButtonGroup>
          <Button
            text={editServiceProvider ? t`Cancel` : t`Change integration`}
            link={true}
            onClick={this.toggleEditServiceProvider}
            iconLeft={!editServiceProvider ? EditIcon : undefined}
          />
        </ButtonGroup>

        <p className="text-gray text-center" style={{ fontStyle: 'italic' }}>
          {!showGenericSyncMessage &&
            ServiceProvider.GOOGLE_FIT === serviceProvider &&
            t`Google Fit syncs automatically when you open the YuMuuv app and also in background every hour.`}
          {ServiceProvider.APPLE_HEALTH === serviceProvider &&
            t`Apple Health syncs automatically when you open the YuMuuv app.`}
          {ServiceProvider.GARMIN === serviceProvider &&
            t`Garmin syncs automatically (in few minutes) after you have synced your device with Garmin Connect.`}
          {/*{t`Polar, Fitbit, and Suunto syncs automatically once an hour.`}*/}
          {showGenericSyncMessage && t`${integration} syncs automatically once an hour.`}
        </p>
      </section>
    )
  }

  setGender = (event: any, gender: any) => this.setState({ gender })

  setUnits = (event: any, units: any) => this.setState({ units })

  setNewsletterSubscriber = (event: any, newsletterSubscriber: any) => this.setState({ newsletterSubscriber })

  getProfileBlock = () => {
    const {
      editProfile,
      email,
      dateOfBirth,
      gender,
      units,
      height,
      heightFt,
      heightIn,
      weight,
      weightLbs,
      lastName,
      firstName,
      isProfileFormValid,
      timeZone,
      newsletterSubscriber,
      hasActivityIndexData,
    } = this.state
    const dateOfBirthFormatted = dateOfBirth
      ? getShortDateString(moment(dateOfBirth.trim(), DATE_FORMAT, true).locale('en').valueOf(), true)
      : ''
    return (
      <section className="settings__section">
        {editProfile ? (
          <div className="settings__form">
            <Grid container spacing={3} style={{ marginBottom: 18 }}>
              <Grid item xs={12} sm={6} style={{ paddingBottom: 0 }}>
                <TextField
                  variant="filled"
                  InputProps={{
                    disableUnderline: true,
                  }}
                  value={firstName || ''}
                  label={t`First name`}
                  fullWidth={true}
                  type="text"
                  name="firstName"
                  required={true}
                  error={isTextFieldErrorVisible(firstName, isProfileFormValid)}
                  style={{
                    marginBottom: 0,
                  }}
                  onChange={this.handleInputChange}
                />
              </Grid>
              <Grid item xs={12} sm={6} style={{ paddingBottom: 0 }}>
                <TextField
                  variant="filled"
                  InputProps={{
                    disableUnderline: true,
                  }}
                  value={lastName || ''}
                  label={t`Last name`}
                  fullWidth={true}
                  type="text"
                  name="lastName"
                  required={true}
                  error={isTextFieldErrorVisible(lastName, isProfileFormValid)}
                  style={{
                    marginBottom: 0,
                  }}
                  onChange={this.handleInputChange}
                />
              </Grid>
            </Grid>

            {hasActivityIndexData && (
              <>
                <FormGroup row={true}>
                  <FormControl component="fieldset" style={{ margin: '0 10px 16px 10px' }}>
                    <FormLabel component="legend" style={{ fontSize: 12 }}>{t`Sex`}</FormLabel>
                    <RadioGroup row={true} name="gender" onChange={this.setGender} value={gender || Gender.MALE}>
                      <FormControlLabel
                        control={<Radio icon={<CheckboxIcon />} checkedIcon={<CheckboxSelectedIcon />} />}
                        value={Gender.MALE}
                        label={t`Male`}
                      />
                      <FormControlLabel
                        control={<Radio icon={<CheckboxIcon />} checkedIcon={<CheckboxSelectedIcon />} />}
                        value={Gender.FEMALE}
                        label={t`Female`}
                      />
                    </RadioGroup>
                  </FormControl>
                </FormGroup>

                <YumInput
                  startIcon={DateActiveIcon}
                  startIconInactive={DateInactiveIcon}
                  label={t`Date of birth`}
                  helperText={t`Format: DD.MM.YYYY`}
                  required={true}
                  error={isDateOfBirthErrorVisible(dateOfBirth, isProfileFormValid)}
                  value={dateOfBirth}
                  onChange={this.handleDOBChange}
                  style={{ marginBottom: '1.5rem' }}
                />

                <FormGroup row={true} className="">
                  <FormControl component="fieldset" style={{ margin: '0 10px 16px 10px' }}>
                    <FormLabel component="legend" style={{ fontSize: 12 }}>{t`Units of measure`}</FormLabel>
                    <RadioGroup
                      row
                      aria-label="units"
                      name="units"
                      onChange={this.setUnits}
                      value={units || Units.METRIC}
                    >
                      <FormControlLabel
                        control={<Radio icon={<CheckboxIcon />} checkedIcon={<CheckboxSelectedIcon />} />}
                        value={Units.METRIC}
                        label={t`Metric`}
                      />
                      <FormControlLabel
                        control={<Radio icon={<CheckboxIcon />} checkedIcon={<CheckboxSelectedIcon />} />}
                        value={Units.IMPERIAL}
                        label={t`Imperial`}
                      />
                    </RadioGroup>
                  </FormControl>
                </FormGroup>

                {units === Units.METRIC && (
                  <Grid container spacing={3} style={{ marginBottom: 8 }}>
                    <Grid item xs={12} sm={6} style={{ paddingBottom: 0 }}>
                      <YumInput
                        startIcon={WeightActiveIcon}
                        startIconInactive={WeightInactiveIcon}
                        label={t`Weight`}
                        type="text"
                        inputProps={{ inputMode: 'numeric', min: MIN_WEIGHT_KG }}
                        InputProps={{
                          endAdornment: <InputAdornment position="end">{unitsCountMassKilogramShort}</InputAdornment>,
                        }}
                        name="weight"
                        value={weight || ''}
                        required={true}
                        error={isNumberFieldErrorVisible(weight, isProfileFormValid, MIN_WEIGHT_KG)}
                        onChange={this.handleInputChange}
                        style={{ marginBottom: 0 }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <YumInput
                        startIcon={HeightActiveIcon}
                        startIconInactive={HeightInactiveIcon}
                        label={t`Height`}
                        value={height || ''}
                        required={true}
                        error={isNumberFieldErrorVisible(height, isProfileFormValid, MIN_HEIGHT_CM)}
                        type="text"
                        inputProps={{ inputMode: 'numeric', min: MIN_HEIGHT_CM }}
                        InputProps={{
                          endAdornment: <InputAdornment position="end">cm</InputAdornment>,
                        }}
                        name="height"
                        onChange={this.handleInputChange}
                        style={{ marginBottom: 0 }}
                      />
                    </Grid>
                  </Grid>
                )}

                {units === Units.IMPERIAL && (
                  <Grid container spacing={3} style={{ marginBottom: 8 }}>
                    <Grid item xs={12} sm={5} style={{ paddingBottom: 0 }}>
                      <YumInput
                        startIcon={WeightActiveIcon}
                        startIconInactive={WeightInactiveIcon}
                        label={t`Weight`}
                        type="text"
                        inputProps={{ inputMode: 'numeric' }}
                        InputProps={{
                          endAdornment: <InputAdornment position="end">{unitsCountMassPoundShort}</InputAdornment>,
                        }}
                        name="weightLbs"
                        value={weightLbs || ''}
                        required={true}
                        error={isNumberFieldErrorVisible(weight, isProfileFormValid, MIN_WEIGHT_KG)}
                        style={{
                          marginBottom: 0,
                        }}
                        onChange={this.handleInputChange}
                      />
                    </Grid>
                    <Grid item xs={12} sm={7}>
                      <Grid container spacing={1}>
                        <Grid item xs={6}>
                          <YumSelect
                            label={t`Height`}
                            startIcon={HeightActiveIcon}
                            value={heightFt}
                            onChange={this.handleHeightFtChange}
                            error={isNumberFieldErrorVisible(height, isProfileFormValid, MIN_HEIGHT_CM)}
                            style={{ marginBottom: 0 }}
                          >
                            {[...Array(7)].map((e, i) => {
                              i += 3
                              return (
                                <option key={i} value={i}>
                                  {i} {unitsCountLengthFootShort}
                                </option>
                              )
                            })}
                          </YumSelect>
                        </Grid>
                        <Grid item xs={6}>
                          <YumSelect
                            label={t`Height`}
                            value={heightIn}
                            onChange={this.handleHeightInChange}
                            error={isNumberFieldErrorVisible(height, isProfileFormValid, MIN_HEIGHT_CM)}
                            style={{ marginBottom: 0 }}
                          >
                            {[...Array(12)].map((e, i) => {
                              return (
                                <option key={i} value={i}>
                                  {i} {unitsCountLengthInchShort}
                                </option>
                              )
                            })}
                          </YumSelect>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </>
            )}

            <FormControl style={{ display: 'block' }}>
              <InputLabel htmlFor="timeZone" required={true}>{t`Time zone`}</InputLabel>
              <YumTimeZoneSelect value={timeZone} onChange={this.handleTimeZoneChange} required={true} />
            </FormControl>

            <FormGroup row={true} style={{ marginTop: '18px' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="newsletterSubscriber"
                    checked={newsletterSubscriber}
                    onChange={this.setNewsletterSubscriber}
                  />
                }
                label={t`Subscribe to newsletter`}
              />
            </FormGroup>
          </div>
        ) : (
          <>
            <div className="text-right">
              <p>
                <span className="text-gray pull-left">{t`Email`}:</span>
                {email}
              </p>
              <p>
                <span className="text-gray pull-left">{t`First name`}:</span>
                {firstName}
              </p>
              <p>
                <span className="text-gray pull-left">{t`Last name`}:</span>
                {lastName}
              </p>
              {hasActivityIndexData && (
                <>
                  <p>
                    <span className="text-gray pull-left">{t`Sex`}:</span>
                    {gender === Gender.FEMALE ? t`Female` : t`Male`}
                  </p>
                  <p>
                    <span className="text-gray pull-left">{t`Date of birth`}:</span>
                    &nbsp;{dateOfBirthFormatted}
                  </p>
                  <p>
                    <span className="text-gray pull-left">{t`Weight`}:</span>
                    {Units.IMPERIAL === units && weightLbs
                      ? `${precisionRoundMod(parseFloat(weightLbs), 5)} ${unitsCountMassPoundShort}`
                      : `${weight} ${unitsCountMassKilogramShort}`}
                  </p>
                  <p>
                    <span className="text-gray pull-left">{t`Height`}:</span>
                    {Units.IMPERIAL === units && heightFt
                      ? `${heightFt} ${unitsCountLengthFootShort} ${heightIn || '0'} ${unitsCountLengthInchShort}`
                      : `${height} ${unitsCountLengthCentimeterShort}`}
                  </p>
                </>
              )}
              <p>
                <span className="text-gray pull-left">{t`Time zone`}:</span>
                &nbsp;{timeZone}
              </p>
              <p>
                <span className="text-gray pull-left">{t`Subscribe to newsletter`}:</span>
                &nbsp;{newsletterSubscriber ? t`Yes` : t`No`}
              </p>
            </div>
          </>
        )}

        <ButtonGroup>
          {editProfile && <Button text={t`Save`} link={false} onClick={this.editProfile} />}
          <Button
            text={editProfile ? t`Cancel` : t`Edit profile`}
            link={true}
            onClick={this.cancelEditProfile}
            iconLeft={!editProfile ? EditIcon : undefined}
          />
        </ButtonGroup>
      </section>
    )
  }

  handleInputChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = target
    this.setState({ [name]: value } as any)

    if ('weight' === name) {
      let weightLbs = convert(value).from('kg').to('lb')
      weightLbs = precisionRoundMod(weightLbs, 5)
      this.setState({ weightLbs })
    }

    if ('weightLbs' === name) {
      let weight = convert(value).from('lb').to('kg')
      weight = precisionRoundMod(weight, 5)
      this.setState({ weight })
    }

    if ('height' === name) {
      const { heightFt, heightIn } = convertCmToFtIn(value)
      this.setState({ heightFt, heightIn })
    }
  }

  handleHeightFtChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const value: number = parseInt(event.target.value as string)
    const height = convertFtInToCm(value, parseInt(this.state.heightIn))
    this.setState({ heightFt: value, height })
  }

  handleHeightInChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const value: number = parseInt(event.target.value as string)
    const height = convertFtInToCm(parseInt(this.state.heightFt), value)
    this.setState({ heightIn: value, height })
  }

  handleDOBChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ dateOfBirth: event.target.value }, () =>
      this.setState({ isProfileFormValid: this.isProfileFormValid() }),
    )
  }

  handleTimeZoneChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    this.setState({ timeZone: event.target.value as string })
  }

  getChangePasswordForm = () => {
    const { editPassword } = this.state
    return (
      <section className="settings__section">
        <Grid container={true}>
          <Grid item={true} xs={12} sm={6} md={4}>
            {editPassword ? (
              <>
                <YumInput
                  startIcon={LockFilledIcon}
                  startIconInactive={LockIcon}
                  label={t`Old password`}
                  type="password"
                  name="oldPassword"
                  onChange={this.handleInputChange}
                  value={this.state.oldPassword}
                />
                <YumInput
                  startIcon={LockFilledIcon}
                  startIconInactive={LockIcon}
                  label={t`New password`}
                  type="password"
                  name="newPassword"
                  onChange={this.handleInputChange}
                  value={this.state.newPassword}
                />
                <YumInput
                  startIcon={LockFilledIcon}
                  startIconInactive={LockIcon}
                  label={t`Confirm password`}
                  type="password"
                  name="confirmPassword"
                  onChange={this.handleInputChange}
                  value={this.state.confirmPassword}
                  style={{ marginBottom: 0 }}
                />
              </>
            ) : (
              ''
            )}

            <ButtonGroup>
              {editPassword && <Button text={t`Save`} link={false} onClick={this.changePassword} />}
              <Button
                text={editPassword ? t`Cancel` : t`Change password`}
                link={true}
                onClick={this.cancelEditPassword}
                iconLeft={!editPassword ? EditIcon : undefined}
              />
            </ButtonGroup>
          </Grid>
        </Grid>
      </section>
    )
  }

  openDeleteModal = () => this.setState({ isDeleteModalOpen: true })
  closeDeleteModal = () => this.setState({ isDeleteModalOpen: false })

  getDeleteModal = () => (
    <>
      <Button
        text={t`Delete account`}
        link={true}
        onClick={this.openDeleteModal}
        iconLeft={DeleteIcon}
        className="btn-delete-account"
      />
      <Dialog open={this.state.isDeleteModalOpen}>
        <DialogTitle>{t`Delete account`}</DialogTitle>
        <DialogContent>
          <DialogContentText>{t`Are you sure you want to delete your account?`}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <ButtonGroup>
            <Button text={t`Delete`} onClick={this.deleteUser} className="bg-red" />
            <Button text={t`Cancel`} link={true} onClick={this.closeDeleteModal} />
          </ButtonGroup>
        </DialogActions>
      </Dialog>
    </>
  )

  getCompaniesBlock = () => {
    const { joinCompany, publicChallengesJustClicked } = this.state
    const { userCompanies, hasRole, divisions, countries } = this.props
    const filteredCompanies = userCompanies?.filter(({ companyId }) => companyId !== yuMuuvPublicCompanyId)

    const onlyHasPublicCompany = userCompanies.length === 1 && filteredCompanies.length === 0
    const publicChallengesAllowed =
      userCompanies?.some(({ publicGoalsEnabled }) => publicGoalsEnabled) || onlyHasPublicCompany || false
    const publicChallengesEnabled = userCompanies?.find(({ companyId }) => companyId === yuMuuvPublicCompanyId)?.active

    const showRole = hasRole(Role.ADMIN) || filteredCompanies?.some(({ active }) => !active)
    const showDivision = divisions.some(({ companyId }) => companyId !== yuMuuvPublicCompanyId)
    const showCountry = countries
      .filter(({ companyId }) => companyId !== yuMuuvPublicCompanyId)
      .some(({ countries }) => !!countries.length)

    return (
      <section className="settings__section">
        <Grid
          container
          spacing={2}
          justifyContent="space-between"
          alignItems="baseline"
          style={{ marginBottom: '20px' }}
        >
          <Grid item xs={12} sm={'auto'}>
            <h3 style={{ marginBottom: 0 }}>{t`Companies & communities`}</h3>
          </Grid>
          <Grid item xs={12} sm={'auto'}>
            {publicChallengesAllowed && (
              <>
                <span
                  onClick={this.togglePublicStatus}
                  style={{ marginRight: isRtl ? 0 : 10, marginLeft: isRtl ? 10 : 0, cursor: 'pointer' }}
                >{t`Public challenges`}</span>
                <YumSwitch
                  checked={publicChallengesEnabled}
                  onChange={this.togglePublicStatus}
                  disabled={publicChallengesJustClicked}
                />
              </>
            )}
          </Grid>
        </Grid>
        <Table
          className="company-table"
          data={filteredCompanies}
          columns={this.companyTableColumns(showRole, showDivision, showCountry)}
        />

        <Grid container>
          <Grid item xs={12} sm={6} md={4}>
            {joinCompany ? (
              <>
                <YumInput
                  startIcon={StarFilledIcon}
                  startIconInactive={StarIcon}
                  label={t`Sign up code`}
                  type="text"
                  name="signUpCode"
                  onChange={this.handleInputChange}
                  value={this.state.signUpCode}
                  style={{ marginBottom: 0 }}
                />
              </>
            ) : (
              ''
            )}

            <ButtonGroup>
              {joinCompany && <Button text={t`Join`} link={false} onClick={this.joinCompany} />}
              <Button
                text={joinCompany ? t`Cancel` : t`Join another`}
                link={true}
                onClick={this.toggleJoinCompany}
                iconLeft={!joinCompany ? AddIcon : undefined}
              />
            </ButtonGroup>
          </Grid>
        </Grid>
        {this.getLeaveModal()}
      </section>
    )
  }

  openLeaveModal = (leaveCompanyId: CompanyId, leaveCompanyName: string, ownerUserId: UserId | null) => {
    this.setState({
      leaveCompanyId,
      leaveCompanyName,
      isLeaveCompanyOwner: this.props.userDto.userId === ownerUserId,
      isLeaveModalOpen: true,
    })
  }
  closeLeaveModal = () => this.setState({ isLeaveModalOpen: false, leaveCompanyId: null, leaveCompanyName: '' })

  leaveCompany = () => {
    if (this.state.leaveCompanyId) {
      this.props.leaveCompany({ companyId: this.state.leaveCompanyId })
      this.closeLeaveModal()
      scrollToTop()
    }
  }

  deleteUserOwnedCompany = () => {
    if (this.state.leaveCompanyId) {
      this.props.deleteUserOwnedCompany({ companyId: this.state.leaveCompanyId })
      this.closeLeaveModal()
      scrollToTop()
    }
  }

  getLeaveModal = () => {
    const { leaveCompanyName, isLeaveCompanyOwner } = this.state
    const companyName = <strong key={'companyName'}>{leaveCompanyName}</strong>
    const title = isLeaveCompanyOwner ? t`Delete community` : t`Leave`
    const msg = isLeaveCompanyOwner
      ? jt`You are the owner of ${companyName}. Are you sure you want to delete it for every member with all it's challenges? This cannot be undone.`
      : jt`Are you sure you want to leave from ${companyName}?`
    return (
      <>
        <Dialog open={this.state.isLeaveModalOpen} style={{ maxWidth: '600px', margin: 'auto' }}>
          <DialogTitle>{title}</DialogTitle>
          <DialogContent>
            <DialogContentText>{msg}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <ButtonGroup>
              <Button
                text={isLeaveCompanyOwner ? t`Delete` : t`Leave`}
                onClick={isLeaveCompanyOwner ? this.deleteUserOwnedCompany : this.leaveCompany}
                className="bg-red"
              />
              <Button text={t`Cancel`} link={true} onClick={this.closeLeaveModal} />
            </ButtonGroup>
          </DialogActions>
        </Dialog>
      </>
    )
  }

  companyTableColumns = (showRole: boolean, showDivision: boolean, showCountry: boolean): Column<any>[] => {
    const useAutocompleteSelect =
      this.props.userCompanies && this.props.userCompanies.some((uc) => uc.scope?.includes('useAutocompleteSelect'))
    const columns = []
    columns.push({
      Header: t`Name`,
      id: 'companyName',
      Cell: ({ original: { companyName } }: CellInfo) => <span>{companyName}</span>,
      accessor: 'companyName',
      style: { alignSelf: 'center' },
      minWidth: 150,
      maxWidth: 300,
    })
    if (showRole) {
      columns.push({
        Header: t`Role`,
        id: 'role',
        Cell: ({ original: { companyId, ownerUserId, active } }: CellInfo) => {
          let role = t`User`
          let color = 'default'
          let variant = 'outlined'
          if (this.props.userDto.userId === ownerUserId) {
            role = t`Owner`
            color = 'primary'
            variant = 'default'
          } else if (this.props.hasRoleInCompany(companyId, Role.ADMIN)) {
            role = t`Admin`
            color = 'primary'
            variant = 'default'
          }
          const deStyle = {
            textTransform: 'uppercase',
            fontSize: 11,
            margin: 0,
            /*marginRight: isRtl ? 10 : 0,
            marginLeft: isRtl ? 0 : 10,*/
          }
          // @ts-ignore
          return role ? (
            <>
              {/* @ts-ignore */}
              <Chip
                color={color}
                variant={variant}
                label={role}
                style={{ textTransform: 'uppercase', fontSize: 11, margin: isRtl ? '0 0 0 5px' : '0 5px 0 0' }}
              />
              {!active && (
                <>
                  {/* @ts-ignore */}
                  <Chip color="secondary" variant="default" label={t`Deactivated`} style={deStyle} />
                </>
              )}
            </>
          ) : (
            ''
          )
        },
        accessor: 'role',
        style: { alignSelf: 'center', flexWrap: 'wrap', overflow: 'hidden' },
        //width: 'auto',
        //width: 150,
        //width: 200,
        minWidth: 135,
        //maxWidth: 200,
      })
    }
    if (showDivision) {
      columns.push({
        Header: t`Team`,
        accessor: 'divisionName',
        Cell: ({ original: { companyId, userId, divisionId } }: RowInfo) => {
          const isDivisionRequired = isCompanyDivisionRequired(companyId)
          const companyDivisions = this.props.divisions.filter((d) => d.companyId === companyId)
          return companyDivisions.length ? (
            <YumTeamSelect
              label={t`Team`}
              companyDivisions={companyDivisions}
              value={divisionId || ''}
              required={isDivisionRequired && divisionId}
              onChange={this.handleDivisionChange(companyId, userId)}
              useAutocompleteSelect={useAutocompleteSelect}
              style={{
                marginBottom: 0,
              }}
            />
          ) : (
            ''
          )
        },
        style: { alignSelf: 'center' },
        width: 250,
      })
    }
    if (showCountry) {
      columns.push({
        Header: t`Country`,
        accessor: 'country',
        Cell: ({ original: { companyId, userId, country } }: CellInfo) => {
          const isCountryRequired = isCompanyCountryRequired(companyId)
          const companyCountries = this.props.countries.find((c) => c.companyId === companyId) || { countries: [] }
          return companyCountries.countries.length ? (
            <YumCountrySelect
              label={t`Country`}
              countries={companyCountries.countries}
              value={country || ''}
              onChange={this.handleCountryChange(companyId, userId)}
              required={isCountryRequired && country}
              useAutocompleteSelect={useAutocompleteSelect}
              style={{
                marginBottom: 0,
              }}
            />
          ) : (
            ''
          )
        },
        style: { alignSelf: 'center' },
        width: 250,
      })
    }
    if (this.props.userCompanies.length > 1) {
      columns.push({
        Cell: ({ original: { companyId, companyName, ownerUserId } }: CellInfo) => (
          /*<Button
            className="button--red ml-auto mr-0"
            link={true}
            onClick={() => this.openLeaveModal(companyId, companyName, ownerUserId)}
            iconLeft={DeleteIcon}
          />*/
          <IconButton
            style={{ color: red }}
            aria-label="delete"
            onClick={() => this.openLeaveModal(companyId, companyName, ownerUserId)}
          >
            {ownerUserId === this.props.userDto.userId ? (
              <DeleteIcon
                style={{
                  /*fontSize: 10*/
                  width: 24,
                  height: 24,
                }}
              />
            ) : (
              <svg
                style={{ padding: 2 }}
                width={24}
                height={24}
                focusable="false"
                aria-hidden="true"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="m17 7-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"></path>
              </svg>
            )}
          </IconButton>
        ),
        sortable: false,
        width: 80,
      })
    }
    return columns
  }

  joinCompany = () => {
    const { joinCompany, userDto } = this.props
    const { signUpCode } = this.state

    if (signUpCode) {
      joinCompany({ userId: userDto.userId, signUpCode })
      this.toggleJoinCompany()
      scrollToTop()
    }
  }

  toggleJoinCompany = () => {
    this.setState({
      joinCompany: !this.state.joinCompany,
      signUpCode: '',
    })
  }

  togglePublicStatus = () => {
    this.props.togglePublicStatus()
    this.setState({ publicChallengesJustClicked: true })

    setTimeout(() => {
      this.setState({ publicChallengesJustClicked: false })
    }, 1000)
  }

  handleDivisionChange = (companyId: CompanyId, userId: UserId) => (event: React.ChangeEvent<{ value: unknown }>) => {
    const { setUserDivision } = this.props
    const { value } = event.target as { value: DivisionId }
    setUserDivision({ companyId, userId, divisionId: value || null })
  }

  handleCountryChange = (companyId: CompanyId, userId: UserId) => (event: React.ChangeEvent<{ value: unknown }>) => {
    const { setUserCountry } = this.props
    const { value } = event.target as { value: string }
    setUserCountry({ companyId, userId, country: value })
  }

  render() {
    const { hasRole, userDto, changeUserLanguage } = this.props
    const { firstName, lastName, email, passwordSet } = userDto
    const fullName = getFullName(firstName, lastName, email)
    const supportEmail = currentLang === Lang.ET ? 'tugi@yumuuv.com' : 'support@yumuuv.com'

    return (
      <div className="settings">
        <Card>
          <NotificationsWrapper />

          <h1>{t`Your details`}</h1>

          {hasRole(Role.USER) && (
            <>
              <Initials className="settings__initials" fullName={fullName} size={'xl'} inline={false} />
              {this.getIntegrationBlock()}
              {this.getProfileBlock()}
              {/*{this.getAchievementBlock()}*/}
            </>
          )}

          <section className="settings__section">
            {this.getGridLayout(
              <p className="text-gray" style={{ lineHeight: '26px' }}>
                {t`Language selection`}:
              </p>,
              <div>
                {/*<LanguageSelection onSubmit={changeUserLanguage} currentLang={getLocale()} />*/}
                <YumLanguageSelection onSubmit={changeUserLanguage} />
              </div>,
            )}
          </section>

          {(passwordSet || hasRole(Role.ADMIN)) && this.getChangePasswordForm()}

          {/*{hasRole(Role.USER) && this.getCompaniesBlock()}*/}
          {this.getCompaniesBlock()}

          <section className="settings__section settings__section--buttons-section">
            <ButtonGroup>
              <Button
                text={supportEmail}
                link={true}
                blue={true}
                externalLink={true}
                iconLeft={EmailIcon}
                url={`mailto:${supportEmail}`}
              />

              <Button
                text={t`Privacy Policy`}
                link={true}
                blue={true}
                iconLeft={PrivacyIcon}
                onClick={openPrivacyPolicy}
              />

              <Button
                text={t`Terms of Service`}
                link={true}
                blue={true}
                iconLeft={PrivacyIcon}
                onClick={openTermsOfService}
              />

              {this.getDeleteModal()}
            </ButtonGroup>
          </section>
        </Card>
      </div>
    )
  }
}
